import React from "react";

const SpaceshipIcon = (props) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="45" height="44" fill="none" viewBox="0 0 45 44" {...props}>
      <path
        fill="#4D6AFA"
        d="M27.78 11.498a2 2 0 012.646 1.818l.721 19.15c.062 1.644-1.776 2.655-3.131 1.724L9.159 21.234c-1.355-.93-1.07-3.01.486-3.54l18.136-6.196z"
      ></path>
      <path
        fill="#5289E3"
        d="M20.317 16.398l-5.971 8.121 1.936-17.883 4.035 9.762zM28.506 22.012l-5.46 8.474 16.02-8.186-10.56-.288z"
      ></path>
      <path
        fill="#5ABAFA"
        d="M14.146 26.679l15.926-23.18a4.246 4.246 0 016.999 4.809l-15.926 23.18-6.999-4.81z"
      ></path>
      <path
        fill="#0B132B"
        d="M17.354 26.244c.53.364.664 1.088.3 1.618l-1.877 2.731-1.919-1.318 1.877-2.731a1.164 1.164 0 011.619-.3zM20.514 28.415c.53.364.665 1.089.3 1.619l-1.876 2.73-1.919-1.318 1.877-2.73a1.164 1.164 0 011.618-.301z"
      ></path>
    </svg>
  );
};

export default SpaceshipIcon;
